/*
 * @Author: yongquan.zhang |  yongquan.zhang01@msxf.com
 * @Date: 2023-12-22 16:02:13
 * @Last Modified by: yongquan.zhang
 * @Last Modified time: 2024-05-23 14:47:35
 */
import request from '@common/axios/requestUtil';
import { resData } from '../util';
import { msSessionStorage } from '@common/utils/cache';
import getAdpPath from '@common/utils/adpPath';
import { TcsContentInfo } from '@common/utils/tcsTool';
import { useBaseStore } from '@common/stores/storage';
// 查询广告 天权2.0
export const queryAdeServiceInfoV2 = async (
  slotCode: string,
  options?: { [key: string]: any },
  hasLoad?: boolean,
  outOptions?: { [key: string]: any },
): Promise<{ [key: string]: any } | undefined> => {
  const params: Array<any> = [];
  const slotCodes = slotCode.split(',');
  // 通过 options 添加外部层级参数
  let outerParams = {};
  if (options && options.outerParams) {
    outerParams = options.outerParams;
    delete options.outerParams;
  }
  const { cooperatorId, appName, refNbr } = useBaseStore();
  slotCodes.forEach((slotCode) => {
    params.push({
      slotCode,
      ...options,
      contractSource: appName,
      cashChannelCode: cooperatorId,
      vccsLoanNo: refNbr,
    });
  });
  const publishInfo = outOptions ? outOptions : await getPublishInfo();
  if (!publishInfo.appKey) {
    return undefined;
  }

  let result: { [key: string]: any } | undefined = undefined;
  const userId = msSessionStorage.get('PUBLIC_USERID');
  const rootUrl = getAdpPath();
  const url = options?.isFunctionalPosition
    ? `${rootUrl}/ms/adefunction/query`
    : `${rootUrl}/ms/ad/query`;

  let requestParams = {
    timeStamps: window._pageTimeStamps,
    userId: options?.userId || (!userId || userId === 'null' ? '' : userId),
    appKey: publishInfo.appKey,
    productCode: publishInfo.productCode,
    adSlots: params,
    ...outerParams,
  };

  if (outOptions) {
    requestParams = Object.assign({}, requestParams, outOptions);
  }

  const data = await request.post(url, requestParams, {
    ignoreErrorCodeList: ['40000000'], // 初始化报错广告位为空
    hasLoad,
    errDialog: false,
  });

  // 天权2.0投放引擎服务数据
  if (data?.sourceType === 1) {
    result = resData(data);
    if (slotCodes.length === 1) {
      return result?.ads ? result.ads[slotCode] : undefined;
    }
    return result;
  }
  return result;
};

export interface TcsServiceInfo {
  apiConfig?: {
    [key: string]: any;
  } | null;
  contentInfo?: {
    [key: string]: TcsContentInfo;
  } | null;
}

export const queryTcsServiceInfo = async (
  params: {
    codeList: string[];
    extendedFiled?: string;
  },
  options?: { hasLoad: boolean },
): Promise<TcsServiceInfo | undefined> => {
  const data = await request.post('/pub/config/tcsContent/V1/query', params, {
    hasLoad: options?.hasLoad ?? false,
    errDialog: false,
  });
  return resData(data);
};

const getPublishInfo = async (): Promise<{ appKey?: string; productCode?: string }> => {
  let appKey = msSessionStorage.get('PUBLIC_APPKEY');
  let productCode = msSessionStorage.get('PUBLIC_PRODUCTCODE');
  if (!appKey || appKey === 'null') {
    await waitAppkeyComplete(3000);
    appKey = msSessionStorage.get('PUBLIC_APPKEY');
    productCode = msSessionStorage.get('PUBLIC_PRODUCTCODE');
  }
  return {
    appKey: appKey && appKey !== 'null' ? appKey : undefined,
    productCode: productCode && productCode !== 'null' ? productCode : undefined,
  };
};

const waitAppkeyComplete = async (maxSeconds: number): Promise<void> => {
  return new Promise((resolve) => {
    let time: number | undefined = undefined;
    const dependOnAppKeyCallback = () => {
      if (time) {
        window.clearTimeout(time);
        time = undefined;
      }
      resolve();
    };
    document.addEventListener('runDependOnAppKey', dependOnAppKeyCallback);
    time = window.setTimeout(() => {
      time = undefined;
      document.removeEventListener('runDependOnAppKey', dependOnAppKeyCallback);
      resolve();
    }, maxSeconds);
  });
};

export type QueryAdeServiceInfoParam = {
  slotCode: string;
} & { [key: string]: any };

export const queryAdeServiceInfoV2WithMultiParams = async (
  ...params: QueryAdeServiceInfoParam[]
): Promise<{ [key: string]: any } | undefined> => {
  const publishInfo = await getPublishInfo();
  if (!publishInfo.appKey) {
    return undefined;
  }
  // ssss
  let result: { [key: string]: any } | undefined = undefined;
  const userId = msSessionStorage.get('PUBLIC_USERID');
  const rootUrl = getAdpPath();
  const url = `${rootUrl}/ms/ad/query`;
  const data = await request.post(
    url,
    {
      timeStamps: window._pageTimeStamps,
      userId: !userId || userId === 'null' ? '' : userId,
      appKey: publishInfo.appKey,
      productCode: publishInfo.productCode,
      adSlots: params,
    },
    {
      ignoreErrorCodeList: ['40000000'], // 初始化报错广告位为空
      errDialog: false,
    },
  );
  // 天权2.0投放引擎服务数据
  if (data?.sourceType === 1) {
    result = resData(data);
    return result?.ads;
  }
  return result;
};
